import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addHighlightPillsSelector = createSelector(testTargetOffersSelector, offers => offers.addHighlightPills || Empty.Object);

export { addHighlightPillsSelector };
